import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ValidationData } from '../../modals/validation-data';

import { RequiredValidation } from '../../shared/required-validation';
import { ErrorStructure } from '../../modals/error-structure';
import { ValidationMapper } from '../../shared/validation-mapper';
import { FeildValidation } from '../../modals/validation-interface';
import { DataSettings } from '../../services/data.settings';
import { FormGroup, FormBuilder } from '@angular/forms';
import {
  inputElementList,
  InputElement
} from '../../modals/form-generator.modal';

@Component({
  selector: 'form-generator',
  templateUrl: './form-generator.component.html',
  styleUrls: ['./form-generator.component.scss']
})
export class FormGeneratorComponent implements OnInit {
  formGroup: FormGroup;

  @Input() formElements: inputElementList[];
  @Output() emitForm = new EventEmitter();
  @Output() emitError = new EventEmitter();
  @Output() onFormUpdate = new EventEmitter();

  inputElements: InputElement[];
  elementName: string;
  validData: ValidationData = {};
  requireValidation = new RequiredValidation();
  isFormSubmitted = false;
  // validation variables
  elementValidation: any = [];
  formOutput = [];
  validationName = [];
  finalArray: ValidationData[] = [];
  errors: ErrorStructure;
  sampleArray: ErrorStructure[] = [];
  errorArray: ErrorStructure[] = [];

  // common counter
  i: number;
  j: number;
  k: number;
  l: number;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    const controls = {};
    this.formElements.forEach((parent: inputElementList) => {
      parent['inputs'].forEach((inputs: InputElement) => {
        if (inputs['formControlName'] != undefined) {
          controls[inputs['formControlName']] = [inputs['value']];
        }
      });
    });
    this.formGroup = this.fb.group(controls);
  }

  validatingForm(event = null) {
    if (event != null) {
      this.isFormSubmitted = event.submitted;
    }
    this.finalArray = [];
    this.errorArray = [];
    this.sampleArray = [];

    // looping through inputs array
    for (this.i = 0; this.i < this.formElements.length; this.i++) {
      this.inputElements = this.formElements[this.i]['inputs'];
      // looping through elements array
      for (this.j = 0; this.j < this.inputElements.length; this.j++) {
        if (
          this.inputElements[this.j]['type'] == 'input' ||
          this.inputElements[this.j]['type'] == 'email'
        ) {
          // getting element name from json
          this.elementName = this.inputElements[this.j]['name'];
          // puting data in interface
          this.validData.name = this.elementName;
          this.validData.error = 'no';
          this.validData.isValid = true;
          // getting element validations from json
          this.elementValidation = this.inputElements[this.j]['validation'];
          // check if validations exists
          if (this.elementValidation != null) {
            // looping through validation array
            this.validationName = [];
            for (this.k = 0; this.k < this.elementValidation.length; this.k++) {
              this.validationName.push(this.elementValidation[this.k]['name']);
            }
            this.validData.list = this.validationName;
            // validing through output json to find value coresponding to element name
            if (this.formOutput.length > 0) {
              for (this.l = 0; this.l < this.formOutput.length; this.l++) {
                if (this.formOutput[this.l][0]['name'] == this.elementName) {
                  // puting data in interface
                  var flag = 1;
                  var value = this.formOutput[this.l][0]['value'];
                  var label = this.formOutput[this.l][0]['label'];
                }
              }
              if (flag == 1) {
                this.validData.value = value;
                this.validData.label = label;
                flag = 0;
              } else {
                this.validData.value = '';
                this.validData.label = label;
              }
            } else {
              this.validData.value = '';
            }
          } else {
            // if no validation found then put default values
            this.validationName = [];
            this.validData.list = this.validationName;
            for (this.l = 0; this.l < this.formOutput.length; this.l++) {
              if (this.formOutput[this.l][0]['name'] == this.elementName) {
                // puting data in interface
                if (this.formOutput[this.l][0]['value'] != null) {
                  this.validData.value = this.formOutput[this.l][0]['value'];
                  this.validData.label = this.formOutput[this.l][0]['label'];
                } else {
                  this.validData.value = '';
                }
              }
            }
          }
          this.finalArray.push(this.validData);
          this.validData = {};
        }
      }
    }
    // applying validatoins on elements
    let validMapper: ValidationMapper;
    validMapper = new ValidationMapper();
    let validInterface: FeildValidation;

    for (this.i = 0; this.i < this.finalArray.length; this.i++) {
      if (
        this.finalArray[this.i]['list'][0] != null &&
        this.finalArray[this.i]['list'][0] != ''
      ) {
        for (const k in this.finalArray[this.i]['list']) {
          validInterface = validMapper.validationMap(
            this.finalArray[this.i]['list'][k]
          );
          switch (this.finalArray[this.i]['list'][k]) {
            case 'required':
              this.finalArray[this.i] = validInterface.validation(
                this.finalArray[this.i]
              );
              break;
            case 'email':
              this.finalArray[this.i] = validInterface.validationEmail(
                this.finalArray[this.i]
              );
              break;
            case 'mobile':
              this.finalArray[this.i] = validInterface.validationPhone(
                this.finalArray[this.i]
              );
              break;
            case 'date':
              this.finalArray[this.i] = validInterface.validationDate(
                this.finalArray[this.i]
              );
          }
          if (!this.finalArray[this.i].isValid) {
            break;
          }
        }
      }
    }
    // pushing errors in finalArray to errorArray
    let errorCheckFlag = 0;
    let errorFlag = 0;
    for (this.i = 0; this.i < this.finalArray.length; this.i++) {
      this.errors = {};
      // check if error exists in any data
      if (this.finalArray[this.i]['isValid'] == false && errorCheckFlag == 0) {
        errorFlag = 1;
        errorCheckFlag = 1;
      }
      // pushing errors in errorArray
      this.errors.name = this.finalArray[this.i]['name'];
      this.errors.error = this.finalArray[this.i]['error'];
      this.errors.isValid = this.finalArray[this.i]['isValid'];
      this.sampleArray.push(this.errors);
    }
    this.errorArray = this.sampleArray;
    // if no errors then emit the data
    if (errorFlag == 0 && event != null) {
      this.emitForm.emit(this.finalArray);
      alert(JSON.stringify(this.finalArray));
    }
  }

  dummyFunction() {
    return true;
  }

  focusFunction() {
    return true;
  }

  changeValidate() {
    if (this.isFormSubmitted) {
      this.validatingForm();
    }
  }

  getTextboxValue(textboxValue: Array<Object>) {
    const key = textboxValue[0]['name'];
    const value = textboxValue[0]['value'];
    let insertFlag = 0;
    for (this.i = 0; this.i < this.formOutput.length; this.i++) {
      if (this.formOutput[this.i][0]['name'] == key) {
        this.formOutput[this.i][0]['value'] = value;
        insertFlag = 1;
        break;
      }
    }
    if (insertFlag == 0) {
      this.formOutput.push(textboxValue);
    }
    if (this.onFormUpdate) {
      this.onFormUpdate.emit(textboxValue[0]);
    }
    this.i = 0;
  }

  getCheckboxValue(checkboxValue: Array<Object>) {
    const key = checkboxValue[0]['name'];
    const value = checkboxValue[0]['value'];
    let insertFlag = 0;
    for (this.i = 0; this.i < this.formOutput.length; this.i++) {
      if (this.formOutput[this.i][0]['name'] == key) {
        this.formOutput[this.i][0]['value'] = value;
        insertFlag = 1;
        break;
      }
    }
    if (insertFlag == 0) {
      this.formOutput.push(checkboxValue);
    }

    if (this.onFormUpdate) {
      this.onFormUpdate.emit(checkboxValue[0]);
    }
    this.i = 0;
  }

  getSelectListValue(selectListValue: Array<Object>) {
    const key = selectListValue[0]['name'];
    const value = selectListValue[0]['value'];
    const label = selectListValue[0]['label'];
    let insertFlag = 0;

    for (this.i = 0; this.i < this.formOutput.length; this.i++) {
      if (this.formOutput[this.i][0]['name'] == key) {
        this.formOutput[this.i][0]['value'] = value;
        this.formOutput[this.i][0]['label'] = label;
        insertFlag = 1;
        break;
      }
    }
    if (insertFlag == 0) {
      this.formOutput.push(selectListValue);
    }
    if (this.onFormUpdate) {
      this.onFormUpdate.emit(selectListValue[0]);
    }
    this.i = 0;
  }

  getDatepickerUpdate(datepickerVlaue: Array<Object>) {
    const key = datepickerVlaue[0]['name'];
    const value = datepickerVlaue[0]['value'];
    const label = datepickerVlaue[0]['label'];
    let insertFlag = 0;

    for (this.i = 0; this.i < this.formOutput.length; this.i++) {
      if (this.formOutput[this.i][0]['name'] == key) {
        this.formOutput[this.i][0]['value'] = value;
        this.formOutput[this.i][0]['label'] = label;
        insertFlag = 1;
        break;
      }
    }
    if (insertFlag == 0) {
      this.formOutput.push(datepickerVlaue);
    }
    if (this.onFormUpdate) {
      this.onFormUpdate.emit(datepickerVlaue[0]);
    }
    this.i = 0;
  }

  getNumberInputValue(numberInputValue: Array<Object>) {
    const key = numberInputValue[0]['name'];
    const value = numberInputValue[0]['value'];
    let insertFlag = 0;
    for (this.i = 0; this.i < this.formOutput.length; this.i++) {
      if (this.formOutput[this.i][0]['name'] == key) {
        this.formOutput[this.i][0]['value'] = value;
        insertFlag = 1;
        break;
      }
    }
    if (insertFlag == 0) {
      this.formOutput.push(numberInputValue);
    }

    if (this.onFormUpdate) {
      this.onFormUpdate.emit(numberInputValue[0]);
    }
    this.i = 0;
  }

  getRadioButtonValue(radioButtonValue: Array<Object>) {
    const key = radioButtonValue[0]['name'];
    const value = radioButtonValue[0]['value'];
    let insertFlag = 0;
    for (this.i = 0; this.i < this.formOutput.length; this.i++) {
      if (this.formOutput[this.i][0]['name'] == key) {
        this.formOutput[this.i][0]['value'] = value;
        insertFlag = 1;
        break;
      }
    }
    if (insertFlag == 0) {
      this.formOutput.push(radioButtonValue);
    }

    if (this.onFormUpdate) {
      this.onFormUpdate.emit(radioButtonValue[0]);
    }
    this.i = 0;
  }

  getTextAreaValue(textAreaValue: Array<Object>) {
    const key = textAreaValue[0]['name'];
    const value = textAreaValue[0]['value'];
    let insertFlag = 0;
    for (this.i = 0; this.i < this.formOutput.length; this.i++) {
      if (this.formOutput[this.i][0]['name'] == key) {
        this.formOutput[this.i][0]['value'] = value;
        insertFlag = 1;
        break;
      }
    }
    if (insertFlag == 0) {
      this.formOutput.push(textAreaValue);
    }
    if (this.onFormUpdate) {
      this.onFormUpdate.emit(textAreaValue[0]);
    }
    this.i = 0;
  }

  getRadioSwitchValue(radioSwitchValue: Array<Object>) {
    const key = radioSwitchValue[0]['name'];
    const value = radioSwitchValue[0]['value'];
    let insertFlag = 0;
    for (this.i = 0; this.i < this.formOutput.length; this.i++) {
      if (this.formOutput[this.i][0]['name'] == key) {
        this.formOutput[this.i][0]['value'] = value;
        insertFlag = 1;
        break;
      }
    }
    if (insertFlag == 0) {
      this.formOutput.push(radioSwitchValue);
    }

    if (this.onFormUpdate) {
      this.onFormUpdate.emit(radioSwitchValue[0]);
    }
    this.i = 0;
  }
}
